import translations from '../../components/location/ts/cs';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('cs', translations);
